/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the leaderboard
 * @export
 */
export const LeaderboardCompetitionStatus = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
} as const;
export type LeaderboardCompetitionStatus = typeof LeaderboardCompetitionStatus[keyof typeof LeaderboardCompetitionStatus];


export function instanceOfLeaderboardCompetitionStatus(value: any): boolean {
    for (const key in LeaderboardCompetitionStatus) {
        if (Object.prototype.hasOwnProperty.call(LeaderboardCompetitionStatus, key)) {
            if (LeaderboardCompetitionStatus[key as keyof typeof LeaderboardCompetitionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeaderboardCompetitionStatusFromJSON(json: any): LeaderboardCompetitionStatus {
    return LeaderboardCompetitionStatusFromJSONTyped(json, false);
}

export function LeaderboardCompetitionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardCompetitionStatus {
    return json as LeaderboardCompetitionStatus;
}

export function LeaderboardCompetitionStatusToJSON(value?: LeaderboardCompetitionStatus | null): any {
    return value as any;
}

export function LeaderboardCompetitionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LeaderboardCompetitionStatus {
    return value as LeaderboardCompetitionStatus;
}

